import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { GLOBAL_IMAGES } from "../../assets/asset";

const ParentAuthLayout = ({
  title,
  description,
  eyebrow = "Parent Access",
  accentLabel = "Parent Portal",
  accent = "Simple access for parents and families",
  accentDescription = "",
  children,
  closeTo = "/tutorinfo",
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    const canGoBack =
      typeof window !== "undefined" &&
      typeof window.history?.state?.idx === "number" &&
      window.history.state.idx > 0;

    if (canGoBack) {
      navigate(-1);
      return;
    }

    navigate(closeTo, { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#f8f3ea] font-mali text-[#1b1b1b]">
      <div className="mx-auto flex min-h-screen max-w-7xl flex-col px-4 pb-10 pt-6 sm:px-6 lg:px-8">
        <header className="border-b border-[#ddd3c6] pb-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <Link className="flex items-center gap-3" to="/tutorinfo">
              <img
                src={GLOBAL_IMAGES.dingo}
                alt="MathDingo"
                className="h-14 w-14 object-contain sm:h-16 sm:w-16"
              />
              <img
                src={GLOBAL_IMAGES.dingoLogoText}
                alt="MathDingo"
                className="h-10 w-auto object-contain sm:h-12"
              />
            </Link>

            <Link
              to="/tutorinfo"
              className="inline-flex items-center rounded-full bg-[#FF5E47] px-5 py-2.5 text-sm font-bold text-white transition hover:bg-[#e64d37] sm:text-base"
            >
              Book a Teacher
            </Link>
          </div>
        </header>

        <main className="flex flex-1 items-center py-10">
          <div className="grid w-full gap-8 lg:grid-cols-[minmax(0,1.05fr)_minmax(420px,0.95fr)]">
            <section className="relative overflow-hidden rounded-[36px] border border-[#ddd3c6] bg-[linear-gradient(135deg,#fff8ef_0%,#f7ead9_42%,#efe5ff_100%)] p-8 shadow-[0_24px_60px_rgba(11,43,102,0.08)] sm:p-10">
              <div className="absolute right-[-40px] top-[-30px] h-36 w-36 rounded-full bg-[#fff0ec]/80 blur-2xl" />
              <div className="absolute bottom-[-50px] left-[-20px] h-44 w-44 rounded-full bg-[#dff2eb]/80 blur-2xl" />

              <div className="relative max-w-xl">
                <span className="inline-flex items-center gap-2 rounded-full bg-white/85 px-4 py-2 text-sm font-bold text-[#9d5229] shadow-sm">
                  <Sparkles size={16} />
                  {eyebrow}
                </span>

                <h1 className="mt-6 text-4xl font-bold leading-tight text-[#0B2B66] sm:text-5xl">
                  {title}
                </h1>

                <p className="mt-5 text-lg leading-8 text-[#334155]">
                  {description}
                </p>

                <div className="mt-8 rounded-[28px] border border-white/80 bg-white/80 p-6 shadow-sm">
                  <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#08059B]">
                    {accentLabel}
                  </p>
                  <p className="mt-3 text-xl font-bold text-[#111827]">
                    {accent}
                  </p>
                  {accentDescription ? (
                    <p className="mt-3 text-base leading-7 text-[#475569]">
                      {accentDescription}
                    </p>
                  ) : null}
                </div>
              </div>
            </section>

            <section className="relative rounded-[36px] border border-[#ddd3c6] bg-white p-6 shadow-[0_24px_60px_rgba(11,43,102,0.08)] sm:p-8">
              <button
                type="button"
                onClick={handleClose}
                className="absolute right-5 top-5 z-10 inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#d7ddff] bg-white text-[#0B2B66] transition hover:border-[#08059B] hover:bg-[#f5f7ff] focus:outline-none focus:ring-2 focus:ring-[#d7ddff]"
                aria-label="Close popup"
              >
                <X size={20} />
              </button>

              {children}
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ParentAuthLayout;
